import FinishedTestingContainer from './FinishedTestingContainer'

export default FinishedTestingContainer
